import React from 'react'
import Step from './Step'

const Steps = () => {
  return (
    <>
      <div id='steps'></div>
      <article className='p-8 md:p-10 lg:p-12 mt-16 flex flex-col items-center justify-center text-center'>
        <h2 className='font-bold text-2xl md:text-3xl lg:text-4xl mb-8 md:mb-14 lg:mb-20'>How it works</h2>
        <table className='mb-6 max-w-xs md:max-w-md xl:max-w-xl'>
          <Step step='1' heading='BOOK ONLINE' description='You can check storage availability and discuss more about the price in our whatsapp.' />
          <Step step='2' heading='PICK UP' description='Optionally you may choose for us to pick your luggage at a certain place.' />
        </table>
      </article>
    </>
  )
}

export default Steps